import fr from "@/i18n/fr.json";

type Dict = Record<string, unknown>;

/**
 * Petit helper i18n lookup par chemin pointé ("formations.form.title").
 * Source unique : `src/i18n/fr.json`. DE/IT arrivent en MVP-1 et MVP-2.
 */
export function t(path: string, fallback?: string): string {
  const segments = path.split(".");
  let current: unknown = fr as Dict;
  for (const seg of segments) {
    if (current && typeof current === "object" && seg in (current as Dict)) {
      current = (current as Dict)[seg];
    } else {
      return fallback ?? path;
    }
  }
  return typeof current === "string" ? current : (fallback ?? path);
}

/**
 * Format un montant en centimes vers `1'234.50 CHF` (séparateur suisse).
 */
export function formatChf(cents: number | null | undefined): string {
  if (cents == null) return "—";
  const value = cents / 100;
  return new Intl.NumberFormat("fr-CH", {
    style: "currency",
    currency: "CHF",
    minimumFractionDigits: 2,
  }).format(value);
}

/** Nom de famille affiché en capitales, quelle que soit la saisie. */
export function familyName(value: string | null | undefined): string {
  const text = (value ?? "").trim();
  if (!text || text === "[Supprimé]") return text;
  return text.toLocaleUpperCase("fr-CH");
}

/** Valeur pour un input date, même si l'API renvoie un timestamp. */
export function dateInputValue(value: string | null | undefined): string {
  if (!value) return "";
  const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  return match?.[1] ?? "";
}

/** Format date ISO `YYYY-MM-DD` (ou timestamp) → `13.05.2026`. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const day = iso.slice(0, 10);
  const [y, m, d] = day.split("-");
  if (!y || !m || !d || d.length !== 2) return "—";
  return `${d}.${m}.${y}`;
}
